import React, { memo, useState } from "react";
import CommonModal from "./CommonModal";
import Button from "../UI/Button";
import Switch from "../UI/Switch";
import Icon from "../../../assets/icons/Icon";

const ConfirmationModal = ({
  getValue,
  onStatusChange,
  isBtn = false,
  btnText = "",
  btnClass = "",
  isSwitch = false,
  isIcon = false,
  iconName = "",
  customIcon = null,
  disabled = false,
  message = "",
  modalTitle = "",
}) => {
  const [isShow, setIsShow] = useState(false);

  const handleModalHide = () => {
    setIsShow(!isShow);
  };

  const handleCheckboxChange = (e) => {
    e.target.blur();
    setIsShow(true);
  };

  return (
    <>
      {isSwitch && (
        <Switch
          getValue={() => getValue()}
          onChange={handleCheckboxChange}
          value={getValue()}
          disabled={disabled}
        />
      )}

      {isBtn && (
        <Button
          className={`btn-sm ${btnClass}`}
          onClick={() => setIsShow(true)}
          isDisabled={disabled}
        >
          {btnText}
        </Button>
      )}

      {isIcon &&
        (customIcon ? (
          <span
            className="btn icon_button"
            onClick={() => !disabled && setIsShow(true)}
            role="button"
            aria-disabled={disabled}
          >
            {customIcon}
          </span>
        ) : (
          <Icon
            name={iconName}
            className="btn  icon_button"
            cursorPointer={true}
            onClick={() => setIsShow(true)}
            disabled={disabled}
          />
        ))}

      {isShow && (
        <CommonModal
          isShow={isShow}
          handleModalHide={handleModalHide}
          modalTitle={modalTitle ? modalTitle : "Change Status"}
          isFooter={false}
          size="sm"
        >
          <div className="confirmation-model">
            <div className="confirmation-model__badge" aria-hidden="true">
              ?
            </div>
            <p className="confirmation-model__eyebrow ">
              Please confirm this action
            </p>
            <h5 className="confirmation-model__title ">
              {message ? `${message}` : "Are you sure you want to continue?"}
            </h5>
            <div className="confirmation-model__button">
              <Button
                className="btn btn_main btn_muted "
                onClick={() => handleModalHide()}
              >
                No
              </Button>
              <Button
                className="btn btn_main"
                onClick={() => {
                  onStatusChange(getValue ? !getValue() : true);
                  handleModalHide();
                }}
                autoFocus={true}
              >
                Yes
              </Button>
            </div>
          </div>
        </CommonModal>
      )}
    </>
  );
};

export default memo(ConfirmationModal);
